import React from "react";
import { Link } from "react-router-dom";
import { footerData } from "../../data/data3";

export default function Footer1() {
    return (
        <div className="mt-12">
            <Link to="/iot-use-cases">
                <h2 className="font-poppins smd:text-[12px] text-[14px] 2xl:text-3xl text-red-500 font-semibold">IOT USE CASES</h2>
            </Link>
            <div className="grid smd:grid-cols-1 pt-3 grid-cols-5 gap-4">
                {footerData.map((item, index) => (
                    <div key={index}>
                        <Link to={item.link}>
                            <h2 className="font-poppins smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold hover:text-red-500 transition-colors">{item.heading}</h2>
                        </Link>
                        <ul className="list-none">
                            {item.content.map((contentItem, i) => (
                                <li key={i} className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                    <Link to={contentItem.link} className="hover:text-red-500 transition-colors">
                                        {contentItem.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}
